<template>
<div>
  <div class="container">
    <form action="" class="form-horizontal">
      <div class="form-group label">
        <h4>Create model</h4><br>
        <vs-input label="Nombre" type="text" class="inputx" v-model="modelPost.name" /><br>
        <vs-select class="ps_select" placeholder="autocomplete" autocomplete label="Tipo" v-model="type">
        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="item,index in types"/>
        </vs-select><br>
        <vs-select class="ps_select" placeholder="autocomplete" autocomplete label="Marca" v-model="brand">
        <vs-select-item :key="index" :value="item.id" :text="item.name" v-for="item,index in brands"/>
        </vs-select><br>
        <div class="mb-3">
          <vs-checkbox class="justify-content-start ps_check" v-model="modelPost.autonomous">Es Autónomo</vs-checkbox>
        </div>
        <vs-button class="bx bxs-paint-roll ml-3" @click="postCreate()" color="darkgreen" type="border" icon="add">Crear</vs-button>
      </div>
    </form>
  </div>
  <br><br>
  <vs-alert class="ps_alert" color="danger" v-if="show">
        {{msg}}
  </vs-alert>
  <vs-alert class="ps_alert" color="success" v-if="show1">
        {{msg}}
  </vs-alert>
</div>
</template>
<script>
import axios from 'axios'
export default {
    name: "modelAdd",
    props:{
    },
    components: {
},
    data:()=>({
    type: String,
    types: Array,
    brand: String,
    brands: Array,
    msg: '',
    show: false,
    show1: false,
    modelPost: {
        "name" : '',
        "vtype_id": '',
        "vbrand_id": '',
        "autonomous": false,
    },
    error_msg: ''
  }),
  methods: {
    scrollInto(elementId) {
      const section = document.querySelector(`#${elementId}`);
      section.scrollIntoView({
        behavior: 'smooth'
      });
    },
    postCreate(){
      this.modelPost.vtype_id = this.type
      this.modelPost.vbrand_id = this.brand
      const url_api = this.$store.state.url_api
      axios.post(url_api + 'api/create/model', this.modelPost).then(response => {
        if (response.data == 'isOk'){
          this.show = false
          this.show1 = true
          this.msg = 'successfully created'
        }
        else{
          this.show = true
          this.show1 = false
          this.msg = response.data
        }
      })
      .catch((error) => {
        this.show = true
        this.show1 = false
        this.msg = error.response.data
      })
    },
    getType(){
      const url_api = this.$store.state.url_api
      axios.get(url_api + 'api/typeList').then(response => {
      this.types = response.data
      this.type = response.data[0].id
      })
      .catch((error) => {
        this.msg = error.response.data
      })
    },
    getBrand(){
      const url_api = this.$store.state.url_api
      axios.get(url_api + 'api/brandList').then(response => {
      this.brands = response.data
      this.brand = response.data[0].id
      })
      .catch((error) => {
        this.msg = error.response.data
      })
    },
  },
  mounted(){
    this.getType()
    this.getBrand()
  }
}
</script>
<style>
.ps_check{
  width: max-content;
}
.ps_alert{
  margin-top: 1em;
}
  .label{
    text-align: left;
  }
.vs-select--label{
  color: #000000B3;
}
.vs-select--item{
  color: darkgreen;
}

element.style {
    font-weight: bold;
}
.vs-select-primary .vs-select--item.activex {
    background: rgb(23, 83, 65);
    color: white;
}
</style>